angular.module 'memberPortal'
  .factory 'memberPortalHttp401Interceptor', ($q, $window) ->
    responseError: (response) ->
      if response.status == 401
        window.ignoreRollbarErrors = true
        $window.location.reload()
      else
        $q.reject(response)
